// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1__e6d043b6dbeaca187c20","cls2":"LanguageSwitcherModal-cls2___a48adcc3a3ebfc0b063 LanguageSwitcherModal-cls1__e6d043b6dbeaca187c20"};